import React, { useContext } from "react";
import { useField } from "react-final-form";
import { IntlContext } from "context";
import { SubCategory } from "types/subCategory";
import ReferenceField from "components/Form/Field/ReferenceField";

interface Props {
    disabled: boolean;
}
const TroubleshootingFields: React.FC<Props> = ({ disabled }) => {
    const intl = useContext(IntlContext);
    const subcategory = useField("subcategory");

    return (
        <>
            {[SubCategory.TROUBLESHOOTING].includes(subcategory.input.value) && (
                <div className="margin-top--4">
                    <ReferenceField
                        variant="chips"
                        refType="device"
                        inputProps={{
                            name: "data.device_type",
                            required: true,
                            disabled: disabled,
                            multiple: true,
                        }}
                        labelProps={{
                            label: intl.formatMessage("service.label.device_type"),
                        }}
                    />
                </div>
            )}
        </>
    );
};

export default TroubleshootingFields;
